export default __webpack_public_path__ + "static/media/group-member-unselect.ecb59147.svg";